import { connect } from 'react-redux'
import { branch, compose, lifecycle, renderNothing } from 'recompose'
import { ModuleShown, EVENTS_LABELS } from 'src/constants/trackingEvents'
import {
  showHomeInsuranceDetail,
  hideHomeInsuranceDetail,
  fetchHomeInsurance as getHomeInsurance
} from 'src/actions/homeInsurance'
import { withElementRef } from 'src/composables'
import { scrollToElement } from 'src/helpers/browser'
import { getRef } from 'src/store/elementReference'
import { HomeInsurancePanel } from 'src/constants/notificationRefs'
import { selectHomeUuid } from 'src/store/selectors/home'
import withEventOnceOnMount from 'src/composables/withEventOnceOnMount'
import {
  selectLoading,
  selectEnabled,
  selectDaysUntilRenewal,
  selectYearsSincePurchase,
  selectEstimatedValue,
  selectShowDetail
} from 'src/store/selectors/homeInsurance'

const HomeInsurancePanelContainer = compose(
  connect(
    state => ({
      homeId: selectHomeUuid(state),
      loading: selectLoading(state),
      showModule: selectEnabled(state),
      daysUntilRenewal: selectDaysUntilRenewal(state),
      yearsSincePurchase: selectYearsSincePurchase(state),
      estimatedValue: selectEstimatedValue(state),
      collapsed: selectShowDetail(state)
    }),
    dispatch => ({
      showDetail: () => {
        const { current: ref } = getRef(HomeInsurancePanel)
        scrollToElement(ref)

        dispatch(showHomeInsuranceDetail())
      },
      hideDetail: () => dispatch(hideHomeInsuranceDetail()),
      fetchHomeInsurance: homeId => dispatch(getHomeInsurance(homeId))
    })
  ),
  lifecycle({
    componentDidMount () {
      const { fetchHomeInsurance, homeId } = this.props
      fetchHomeInsurance(homeId)
    }
  }),
  branch(({ loading, showModule }) => !showModule || loading, renderNothing),
  withElementRef(HomeInsurancePanel),
  withEventOnceOnMount(ModuleShown, {
    eventLabel: EVENTS_LABELS.HomeInsuranceModule
  })
)

export default HomeInsurancePanelContainer
